import * as constType from '@js/constants/actionsTypes';
import {
  finalClassic2Products, finalReal2Products, finalGift1Products, finalProduct,
  finalZhNoodlesAdvData, finalZhSauceAdvData, finalZhEvaluateAdvData, finalJohnsHomeAdvData,
} from '@js/controller/JohnsController';

const johnsMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    // 經典拌麵
    case 'MID_GET_CLASSIC_PRODUCTS': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_CLASSIC_PRODUCTS,
        payload: finalClassic2Products,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // 有料拌麵
    case 'MID_GET_REAL_PRODUCTS': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_REAL_PRODUCTS,
        payload: finalReal2Products,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // 禮盒專區
    case 'MID_GET_GIFT_PRODUCTS': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_GIFT_PRODUCTS,
        payload: finalGift1Products,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // 醬的醬
    case 'MID_GET_PRODUCTS': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_PRODUCTS,
        payload: finalProduct,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // zhNoodlesAdv
    case 'MID_GET_ZHNOODLES_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZHNOODLES_ADV,
        payload: finalZhNoodlesAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // zhSauceAdv
    case 'MID_GET_ZHSAUCE_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZHSAUCE_ADV,
        payload: finalZhSauceAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // zhEvaluateAdv
    case 'MID_GET_ZHEVALUATE_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_ZHEVALUATE_ADV,
        payload: finalZhEvaluateAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    // johnsHomeAdv
    case 'MID_GET_JOHNS_HOME_ADV': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      store.dispatch({
        type: constType.GET_JOHNS_HOME_ADV,
        payload: finalJohnsHomeAdvData,
      });
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }
    default:
      return next(action);
  }
};

export default johnsMiddleware;
